import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { UseFormReturn } from 'react-hook-form';
import { PatientFormData } from './patientForm.types';

const PatientFormInsuranceSection = ({ form }: { form: UseFormReturn<PatientFormData> }) => (
  <div className='space-y-4'>
    <h3 className='text-[0.8rem] font-semibold uppercase text-[#60378B]'>
      Insurance Information
    </h3>
    <p className='text-xs text-slate-500'>All insurance fields are optional.</p>
    <div className='space-y-1.5'>
      <Label htmlFor='insurance_carrier'>Insurance Carrier</Label>
      <Input
        id='insurance_carrier'
        placeholder='e.g. BlueCross BlueShield'
        {...form.register('insurance_carrier')}
      />
      {form.formState.errors.insurance_carrier && (
        <p className='text-[0.8rem] text-red-500'>{form.formState.errors.insurance_carrier.message}</p>
      )}
    </div>
    <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
      <div className='space-y-1.5'>
        <Label htmlFor='insurance_member_id'>Member ID</Label>
        <Input
          id='insurance_member_id'
          placeholder='Enter member ID'
          {...form.register('insurance_member_id')}
        />
        {form.formState.errors.insurance_member_id && (
          <p className='text-[0.8rem] text-red-500'>{form.formState.errors.insurance_member_id.message}</p>
        )}
      </div>
      <div className='space-y-1.5'>
        <Label htmlFor='insurance_group_id'>Group ID</Label>
        <Input
          id='insurance_group_id'
          placeholder='Enter group ID'
          {...form.register('insurance_group_id')}
        />
        {form.formState.errors.insurance_group_id && (
          <p className='text-[0.8rem] text-red-500'>{form.formState.errors.insurance_group_id.message}</p>
        )}
      </div>
    </div>
  </div>
);

export default PatientFormInsuranceSection;
